module.exports = __webpack_public_path__ + "img/4-2-4-3-9-preview-Nokky-e.4a97b405.jpg";